/**
 * Object xử lý event global trên toàn bộ hệ thống
 * @author DNThang - 17.03.2020
 * HTHIEP migrate sang vue3
 */
import emitter from 'tiny-emitter/instance';

const eventStates = {};

export default {
  $on: (event, ...args) => {
    emitter.on(event, ...args);
    eventStates[event] = true;
  },
  $once: (event, ...args) => {
    emitter.once(event, ...args);
    eventStates[event] = true;
  },
  $off: (event, ...args) => {
    emitter.off(event, ...args);
    eventStates[event] = false;
  },
  $emit: (...args) => emitter.emit(...args),
  $isOn: event => !!eventStates[event],
};

/**
 * Đối tượng liệt kê các global event đang có
 * Bắt buộc có globalEvent nào đều phải cấu hình vào đây để không bị trùng tên
 * @author DNThang - 17.03.2020
 */
const GlobalEventName = {
  changeDatabaseName: 1, // Đổi tên database đang sử dụng thì sẽ đổi lại context
  changePostedDate: 2,
  gridReload: 'gridReload',
  clearToast: 'clearToast',
  gridReloadDVC: 'gridReloadDVC', // Sự kiện load lại trang danh sách hồ sơ tại Kho bạc nhà nước (nvthinh 15.11.2023)
  // show tiến trình sao lưu dữ liệu
  showBackupProcess: 'showBackupProcess',
  // show tiến trình phục hồi dữ liệu
  showRestoreProcess: 'showRestoreProcess',
  // reload lại danh sách quản lý dữ liệu
  reloadListDbManagement: 'reloadLstDbManagement',
  // reload lại danh sách sao lưu và phục hồi
  reloadListBackupRestore: 'reloadLstBackupRestore',
  // hủy sao lưu dữ liệu
  backupDataCancel: 'backupDataCancel',
  // kết thúc sao lưu dữ liệu
  backupDataCompleted: 'backupDataCompleted',
  // kết thúc tạo dữ liệu từ dữ liệu cũ
  createDataFromOldDataComplete: 'createDataFromOldDataComplete',
  // bắt đầu tạo dữ liệu từ dữ liệu cũ
  createDataFromOldDataStart: 'createDataFromOldDataStart',
  // kết thức khôi phục dữ liệu
  restoreDataCompleted: 'restoreDataCompleted',
  // show tiến trình bảo trì dữ liệu
  showMaintainProcess: 'showMaintainProcess',
  // Sinh CT từ CT Salagov
  generateVoucherFromSalagov: 'generateVoucherFromSalagov',
  // Kết chuyển nhanh
  quickTransfer: 'quickTransfer',
  // Dữ liệu grid trống
  emptyDataGrid: 'emptyDataGrid',
  //  Dữ liệu dashboard
  dashboardData: 'dashboardData',
  // record lại danh sách thông tin hóa đơn mua hàng kbnguyet 25.06.2024
  gridReloadInbotList: 'gridReloadInbotList',
  // sự kiện load lại danh sách hóa đơn mua hàng lần đầu 25.06.2024
  gridReloadInbotListFirstTime: 'gridReloadInbotListFirstTime:',
  // kiểm tra định mức
  checkExpenseNormRegulation: 'checkExpenseNormRegulation:',
  //  Chuyển step tiếp theo
  processNextStep: 'processNextStep',
  //  End tour
  closeTour: 'closeTour',
  //  Bắt đầu 1 luồng hướng dẫn mới
  changedBussinessTour: 'changedBussinessTour',
  //  Thực hiện thay đổi kiểm tra định mức
  doCheckNormData: 'doCheckNormData',
  // load lại paging khi thay đổi thiết lập
  reloadPagingSetting: 'reloadPagingSetting',
  // Khôi phục chứng từ thành công
  restoreVoucherSuccess: 'restoreVoucherSuccess',
  // Sao chép dữ liệu
  copyData: 'copy_data',
};

export {GlobalEventName};
